import React, { useCallback, useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import FormInput from 'components/Input/FormInput';

interface IProps {
	onChange: (value: string) => void;
	setId: string;
}

export const SbpContractNumber: React.FC<IProps> = React.memo(({ onChange, setId }) => {
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterSbpContractNumber') }], [t]);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const valueWithoutSpaces = e.target.value.replace(/\s/g, '');
			onChange(valueWithoutSpaces);
			return valueWithoutSpaces;
		},
		[onChange],
	);

	return (
		<FormInput
			testId="SbpContractNumber"
			name={`sbpContractNumber-${setId}`}
			label="sbpContractNumberLabel"
			getValueFromEvent={handleChange}
			validationRules={validationRules}
		/>
	);
});
